
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-basemap_layer",
  "use": "icon-rescls-basemap_layer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-basemap_layer\"><path fill=\"#00b77e\" d=\"M18.1 6.45v8.61c0 .904-.122 1.38-.326 1.76a2.34 2.34 0 0 1-.961.961c-.38.204-.855.326-1.76.326h-8.62v1.4c0 .866.089 1.18.26 1.5.166.313.421.569.734.734.317.17.631.26 1.5.26h10.6c.867 0 1.18-.09 1.5-.26.313-.166.569-.422.734-.734.17-.316.26-.63.26-1.5v-10.6c0-.866-.09-1.18-.26-1.5a1.76 1.76 0 0 0-.734-.734c-.317-.17-.631-.26-1.5-.26z\" /><path fill=\"#00b77e\" d=\"M8.92 6.45c-.867 0-1.18.089-1.5.26a1.77 1.77 0 0 0-.734.734c-.17.316-.26.63-.26 1.5v6.11h8.61c-.006-2.9-.004-6.47-.002-8.6z\" /><path fill=\"#106a90\" fill-rule=\"evenodd\" d=\"M15.1 2.01H4.5c-.867 0-1.18.09-1.5.26a1.76 1.76 0 0 0-.734.734c-.171.316-.26.631-.26 1.5v10.6c0 .866.09 1.18.26 1.5.169.316.418.565.734.734.317.17.631.26 1.5.26h10.6c.867 0 1.18-.09 1.5-.26a1.75 1.75 0 0 0 .734-.734c.17-.316.26-.631.26-1.5v-10.6c0-.866-.09-1.18-.26-1.5a1.77 1.77 0 0 0-.734-.734c-.317-.171-.631-.26-1.5-.26M4 15.61V3.91h11.7s-.011 7.8 0 11.7z\" clip-rule=\"evenodd\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-basemap_layer"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-basemap_layer";

        export default Icon;
    